import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 8px;
  background-color: white;
  padding: 0px;
  box-sizing: border-box;
  font-family: Inter;

  .error {
    font-size: 12px;
    font-weight: normal;
    color: red;
  }

  .button-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 0px 12px;
  }

  .disabled {
    opacity: 0.5;
    :hover {
      cursor: not-allowed !important;
    }
  }
`;

export const SharedContainer = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
`;

export const Banner = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  height: 96px;
  border-radius: 8px 8px 0px 0px;
  padding: 28px 28px 0px 28px;
  box-sizing: border-box;
  background: linear-gradient(268.28deg, #06d986 0%, #4a76fb 100%);
`;

export const Photo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  align-items: center;
  position: absolute;
  z-index: 10;
  top: 48px;
  width: fit-content;
  border: double 3px transparent;
  background-image: linear-gradient(268.28deg, #06d986 0%, #4a76fb 100%);
  background-origin: border-box;
  background-clip: padding-box, border-box;
  padding: 3px;
  border-radius: 50%;
`;

export const PhotoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  min-width: 190px;
  max-width: 190px;

  #photo-placeholder {
    width: 132px;
    height: 112px;
  }

  .change {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border-radius: 8px;
    p {
      font-size: 14px;
      font-weight: 500;
      color: #2d5bff;
    }
    :hover {
      cursor: pointer;
      background-color: #d5deff;
    }
  }
`;

export const PerfilContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 14px;
  padding: 28px;
  box-sizing: border-box;
  background: gray;
  background: linear-gradient(268.28deg, #e3f9f0 0%, #ecf1ff 100%);

  .name {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 20px;
    font-weight: 600;
    color: #424248;
    text-transform: uppercase;
  }

  .field {
    display: inline-flex;
    gap: 6px;
    align-items: center;
    font-size: 16px;
    font-weight: 400;
    color: #646363;
    line-height: normal;
    white-space: nowrap;

    span {
      display: block;
      color: black;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .clickable {
      display: flex;
      align-items: center;
      gap: 6px;

      .icon {
        color: #2d5bff;
        font-size: 18px !important;
        cursor: pointer;
      }
    }
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  width: 100%;
  padding-left: 210px;
  box-sizing: border-box;
  .name {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 20px;
    font-weight: 600;
    color: #424248;
    text-transform: uppercase;
  }

  .buttons {
    display: flex;
    gap: 12px;
    width: fit-content;
  }
`;

export const InfoBody = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
`;

export const Footer = styled.div`
  display: flex;
  width: 100%;
  gap: 20px;

  .edit {
    display: flex;
    align-items: flex-start;
    height: 100%;
    width: max-content;

    .icon {
      cursor: pointer;
      color: black;
      :hover {
        color: #2d5bff !important;
      }
    }
  }
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 360px;
  width: 100%;
`;

export const Contato = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: fit-content;
  height: fit-content;
  background: #cfeedc;
  border-radius: 8px;
  padding: 20px;
  box-sizing: border-box;
  text-align: start;

  .title-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    h1 {
      font-size: 18px;
      font-weight: 500;
    }
    .icon {
      cursor: pointer;
      color: black;
      :hover {
        color: #2d5bff !important;
      }
    }
  }

  .contact-icon {
    display: flex;
    align-items: center;
    gap: 8px;
    p {
      font-size: 16px;
      font-weight: 400;
      color: #646363;
      max-width: 275px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: normal;
    }
  }

  .mt {
    margin-top: 12px;
  }
`;

export const Creci = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: fit-content;
  height: fit-content;
  background: #e1e9d1;
  border-radius: 8px;
  padding: 20px;
  box-sizing: border-box;
  text-align: start;

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    h1 {
      font-size: 18px;
      font-weight: 500;
    }
    .icon {
      font-size: 18px !important;
      cursor: pointer;
      color: black;
      :hover {
        color: #2d5bff !important;
      }
    }
  }

  .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    p {
      font-size: 16px;
      font-weight: 400;
      color: #646363;
    }

    .clickable {
      cursor: pointer;
      :hover {
        color: #2d5bff;
      }
    }
  }

  .mt {
    margin-top: 6px;
  }
`;

export const MetodoPagamento = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: fit-content;
  height: fit-content;
  background: #ceecc5;
  border-radius: 8px;
  padding: 20px;
  box-sizing: border-box;
  text-align: start;

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    h1 {
      font-size: 18px;
      font-weight: 500;
    }
    .icon {
      font-size: 18px !important;
      cursor: pointer;
      color: black;
      :hover {
        color: #2d5bff !important;
      }
    }
  }

  .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    p {
      font-size: 16px;
      font-weight: 400;
      color: #646363;
      max-width: 320px;
      span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .clickable {
      cursor: pointer;
      :hover {
        color: #2d5bff;
      }
    }
  }

  .mt {
    margin-top: 6px;
  }
`;

export const Bar = styled.div<{ height?: number }>`
  width: 1px;
  height: ${(props) => props.height ?? 18}px;
  border-left: 1px solid #646363;
`;

export const ExtrasContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 14px 28px 28px 28px;
  box-sizing: border-box;
  width: 100%;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  margin: inherit;
`;
